import { Button } from "@/components/bnp-ui";
import { formatNumber } from "@/utils/formatNumber";
import Link from "next/link";
import React, { useState } from "react";

const StepTwo = ({
  amountPayable,
  selectedSource,
  setSelectedSource,
  walletDetails,
}: any) => {
  const handleSourceChange = (source: any) => {
    setSelectedSource(source);
  };

  return (
    <div className="w-full max-w-3xl mx-auto p-4">
      <div className="w-full mb-6">
        <p className="text-sm font-semibold text-main-900 mb-2">
          Amount payable
        </p>
        <div className="flex items-center text-gray-500 p-4 cursor-not-allowed bg-gray-100 w-full h-[52px] rounded-lg">
          <p>₦{formatNumber(amountPayable)}</p>
        </div>
      </div>

      <div className="w-full mb-6">
        <div className="w-full mt-2">
          <p className="text-sm font-semibold text-main-900 mb-4">
            Select source of payment
          </p>
          <div className="flex space-x-4">
            {[
              { id: "wallet", label: "Wallet" },
              { id: "paystack", label: "Paystack" },
            ].map((option) => (
              <div
                key={option.id}
                className="relative flex items-center justify-center border rounded-lg p-4 w-full h-16 transition-colors ease-linear delay-200 cursor-pointer hover:border-bnp-cyan"
                onClick={() => handleSourceChange(option.label)}
              >
                <div className="flex items-center">
                  <div
                    className={`w-4 h-4 rounded-full border-2 flex items-center justify-center mr-2 ${
                      selectedSource === option.label
                        ? "border-bnp-cyan"
                        : "border-gray-300"
                    }`}
                  >
                    {selectedSource === option.label && (
                      <div className="w-4 h-4 rounded-full bg-bnp-cyan"></div>
                    )}
                  </div>
                  <span className="text-gray-700 font-medium">
                    {option.label}
                  </span>
                </div>
              </div>
            ))}
          </div>

          {selectedSource === "Wallet" && (
            <div>
              <div className="flex gap-2 text-sm text-grey-7 mt-4">
                <p>Wallet balance:</p>
                <p>
                  ₦
                  {walletDetails?.isWalletAvailable
                    ? walletDetails?.wallet?.available_balance
                    : "0"}
                </p>
              </div>

              {walletDetails?.isWalletAvailable &&
                walletDetails?.wallet?.available_balance < amountPayable && (
                  <div className="flex justify-between items-center bg-orange-50 p-4 rounded-lg mt-4 ">
                    <div className="flex items-center">
                      <div className="w-8 h-8 rounded-full bg-orange-100 flex items-center justify-center mr-3">
                        <span className="text-orange-500 font-bold">i</span>
                      </div>

                      <div>
                        <p className="text-sm font-semibold text-main-900">
                          Insufficient funds for the action
                        </p>
                        <p className="text-grey-7 text-sm">
                          Please fund your wallet to finish the request process
                        </p>
                      </div>
                    </div>
                    <Link href={`/user/dashboard/payments`}>
                      <Button className="bg-bnp-dark font-semibold text-white text-sm  px-4 py-2 rounded-lg">
                        Fund wallet
                      </Button>
                    </Link>
                  </div>
                )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default StepTwo;
